import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/apply/app/version',
    name: 'plugin36AppVersion',
    component: () => import('@/views/apply/app/version.vue'),
    meta: {
      title: i18n.t('router.app.version_manage'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/app/settings',
    name: 'plugin36AppSettings',
    component: () => import('@/views/apply/app/settings.vue'),
    meta: {
      title: i18n.t('router.app.native_app_config'),
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/app.js